// extracted by mini-css-extract-plugin
export default {"root":"OptionItem_root__+3cSX","active":"OptionItem_active__AQlwk","title":"OptionItem_title__1tipQ","boxIcon":"OptionItem_boxIcon__L0X8k","thumbnail":"OptionItem_thumbnail__GcGsc"};